import React, { useState } from "react";
import Meter from "../components/SignUpComponents/Meter";
import FormUserDetails from "../components/SignUpComponents/FormUserDetails";
import VerifyOTP from "../components/SignUpComponents/VerifyOTP";
import SignupSuccess from "../components/SignUpComponents/SignupSuccess";
import SEO from "../components/Seo/Seo";

function SignUp() {
  const [step, setStep] = useState(1);
  const [meterNumber, setMeterNumber] = useState("");
  const [signupPayload, setSignupPayload] = useState(null);

  const nextStep = () => {
    setStep((step) => step + 1);
  };
  const prevStep = () => {
    setStep((step) => step - 1);
  };

  // Called by FormUserDetails after OTP is requested
  const handleFormComplete = (payload) => {
    setSignupPayload(payload);
    nextStep();
  };

  const getContent = () => {
    switch (step) {
      default:
        return (
          <Meter
            nextStep={nextStep}
            meterNumber={meterNumber}
            setMeterNumber={setMeterNumber}
          />
        );
      case 2:
        return (
          <FormUserDetails
            prevStep={prevStep}
            onFormComplete={handleFormComplete}
            meterNumber={meterNumber}
          />
        );
      case 3:
        return (
          <VerifyOTP
            email={signupPayload?.email}
            signupPayload={signupPayload}
            prevStep={prevStep}
            nextStep={nextStep}
          />
        );
      case 4:
        return <SignupSuccess prevStep={prevStep} />;
    }
  }

  return (
    <div>
      <SEO title="Register" type="signup" />
      {getContent()}
    </div>
  )
}

export default SignUp;
